import { useRouter } from "next/router";
import { useMemo } from "react";
import { numberCheck } from "@common/NumberCheck";

export const useProductPageType = () => {
  const router = useRouter();

  const lastSlug = useMemo(() => {
    if (!router.isReady) return null;
    const pathSegments = router.asPath.split("/").filter(Boolean);
    return pathSegments[pathSegments.length - 1];
  }, [router.asPath, router.isReady]);

  const isDetailPage = useMemo(() => {
    if (!lastSlug || !lastSlug.startsWith("P")) return false;
    const numberPart = lastSlug.slice(1);
    return numberCheck(numberPart); // 숫자인지 확인
  }, [lastSlug]);

  return { isDetailPage, lastSlug };
};
